export enum StatusCode {
  OK = 200,
  CREATED = 201,
  REDIRECT = 302,
  UNPROCESSED_ENTITY = 422,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404
}
